import { ScrollBtn } from './styles';
import { MdKeyboardArrowUp } from 'react-icons/md';
import { animateScroll as scroll } from 'react-scroll';

const ScrollUpButton = ({ isScrollDown }) => {
  const handleScrollTop = () => {
    scroll.scrollToTop({
      duration: 500,
    });
  };

  return (
    <ScrollBtn isScrollDown={isScrollDown} onClick={handleScrollTop}>
      <MdKeyboardArrowUp />
    </ScrollBtn>
  );
};

export default ScrollUpButton;
